import { MenuItem, TextField } from '@mui/material';
import {
  countryOptions,
  southAfricanProvinceOptions,
} from '@utils/countries-provider';
import UseFormSelect from '@components/use-form-select';
import _ from 'lodash';
import { FC } from 'react';
import { IAddress } from '../../../types';

export const INIT_DATA: IAddress = {
  addressType: 1,
  country: 'South Africa',
  countryCode: '710',
  countryIso2Code: 'ZA',
  region: '',
  localArea: '',
  city: '',
  street: '',
  house: '',
  apartmentNumber: '',
  buildingName: '',
  postCode: '',
  residentialStatus: 0,
  jumioIsVerified: false,
  jumioVerificationState: 0,
};

const AddressFields: FC<any> = ({
  data,
  register,
  errors,
  control,
  path = 'address.',
  isDisabled = false,
}) => {
  return (
    <>
      <UseFormSelect
        fullWidth
        control={control}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}countryIso2Code`)}
        helperText={_.get(errors, `${path}countryIso2Code`)?.message}
        label="Country"
        name={`${path}countryIso2Code`}
        variant="outlined"
      >
        {countryOptions.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </UseFormSelect>

      {data.countryIso2Code === 'ZA' && (
        <UseFormSelect
          fullWidth
          control={control}
          disabled={isDisabled}
          error={!!_.get(errors, `${path}region`)}
          helperText={_.get(errors, `${path}region`)?.message}
          label="Region"
          name={`${path}region`}
          variant="outlined"
        >
          {southAfricanProvinceOptions.map((option: any) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </UseFormSelect>
      )}
      <TextField
        fullWidth
        required
        label="Suburb or area"
        placeholder=""
        variant="outlined"
        {...register(`${path}localArea`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}localArea`)}
        helperText={_.get(errors, `${path}localArea`)?.message}
      />
      <TextField
        fullWidth
        required
        label="City or town"
        placeholder=""
        variant="outlined"
        {...register(`${path}city`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}city`)}
        helperText={_.get(errors, `${path}city`)?.message}
      />
      <TextField
        fullWidth
        required
        label="Street"
        placeholder=""
        variant="outlined"
        {...register(`${path}street`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}street`)}
        helperText={_.get(errors, `${path}street`)?.message}
      />
      <TextField
        fullWidth
        required
        label="House number"
        placeholder=""
        variant="outlined"
        {...register(`${path}house`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}house`)}
        helperText={_.get(errors, `${path}house`)?.message}
      />
      <TextField
        fullWidth
        label="App, flat or floor number"
        placeholder=""
        variant="outlined"
        {...register(`${path}apartmentNumber`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}apartmentNumber`)}
        helperText={_.get(errors, `${path}apartmentNumber`)?.message}
      />
      <TextField
        fullWidth
        label="Building or complex"
        placeholder=""
        variant="outlined"
        {...register(`${path}buildingName`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}buildingName`)}
        helperText={_.get(errors, `${path}buildingName`)?.message}
      />
      <TextField
        fullWidth
        required
        label="Postal code"
        placeholder=""
        variant="outlined"
        {...register(`${path}postCode`)}
        disabled={isDisabled}
        error={!!_.get(errors, `${path}postCode`)}
        helperText={_.get(errors, `${path}postCode`)?.message}
      />
    </>
  );
};

export default AddressFields;
